import { geoLangs } from '@functions/geo-functions';

export const getGeoFromLocalePath = (path: string) =>
  geoLangs.find((geo) => path.startsWith(`/${geo.locale}`));
export const getGeoFromPath = (path: string) =>
  geoLangs.find((geo) => path.startsWith(geo.geoLoc)) ?? getDefaultGeo();
export const getGeoFromLocale = (locale: string) =>
  geoLangs.find((geo) => locale === geo.locale) ?? getDefaultGeo();
export const getGeoFromProductGeo = (productGeo: string) =>
  geoLangs.find((geo) => productGeo === geo.productGeo) ?? getDefaultGeo();
export const getDefaultGeo = () => geoLangs.find((geo) => geo.isDefault)!;

export { type GeoLang } from '@repo/ui/src/types/geo';
